//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { InstagramPostUploaderActionType } from '@instagram-post-uploader/actions/instagramPostUploaderActions';
import { INSTAGRAM_POST_UPLOADER_ACTIONS } from '@instagram-post-uploader/constants/instagramPostUploaderConstants';
import { IInstagramPostUploader } from '@instagram-post-uploader/model/instagramPostUploaderModel';

const initialState: IInstagramPostUploader = {
  errorMessage: '',
  isModalOpen: false,
  isPostUrlValid: false,
  isUploadingPost: false,
  pageContext: undefined,
  urlToUpload: '',
};

export default function InstagramPostUploaderReducer(
  state: IInstagramPostUploader = initialState,
  action: InstagramPostUploaderActionType,
) {
  switch (action.type) {
    case INSTAGRAM_POST_UPLOADER_ACTIONS.SET_CONTEXT: {
      return {
        ...state,
        pageContext: action.pageContext,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.OPEN_MODAL: {
      return {
        ...state,
        isModalOpen: true,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.CLOSE_MODAL: {
      return {
        ...state,
        isModalOpen: false,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.UPDATE_POST_URL_VALUE: {
      return {
        ...state,
        urlToUpload: action.urlToUpload,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.VALIDATE_POST_URL_VALUE: {
      return {
        ...state,
        isPostUrlValid: action.isValid,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.REQUEST_POST_UPLOAD: {
      return {
        ...state,
        isUploadingPost: true,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.RECEIVE_POST_UPLOAD_SUCCEEDED: {
      return {
        ...state,
        isUploadingPost: false,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.RECEIVE_POST_UPLOAD_FAILED: {
      return {
        ...state,
        isUploadingPost: false,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.UPDATE_ERROR_MESSAGE: {
      return {
        ...state,
        errorMessage: action.message,
      };
    }
    case INSTAGRAM_POST_UPLOADER_ACTIONS.RESET_ERROR_MESSAGE: {
      return {
        ...state,
        errorMessage: '',
      };
    }
    default: return state;
  }
}
